import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Response } from '@angular/http';

export class ResponseUtil {

  static unwrapErrorMessage(response: Response): ErrorObservable {
    let customMessage = '';
    if (response.json() && response.json().error) {
      customMessage = response.json().error;
    }
    const errorMessage = `Response with status ${response.status}: ${customMessage}`;
    return Observable.throw(errorMessage);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/utils/response-util.ts